// Route mapping util for Next.js app

export const routes = {
  // Admin
  admin: '/admin',
  adminCalendar: '/admin/calendar',
  adminCreateEvent: '/admin/event/create',
  adminEvent: (eventId: string) => `/admin/event/${eventId}`,

  // Auth
  authLogin: '/auth/login',
  authForgotPassword: '/auth/forgot-password',
  authForgotPasswordFailed: '/auth/forgot-password/failed',
  authForgotPasswordSent: '/auth/forgot-password/sent',
  authForgotPasswordChangeFailed: '/auth/forgot-password-change/failed',
  authForgotPasswordChangeSuccess: '/auth/forgot-password-change/success',
  authSetPassword: (token: string) => `/auth/set-password/${token}`,

  // Settings
  adminSettings: '/admin/settings',
  adminSettingsServices: '/admin/settings/services',
  adminSettingsCompanies: '/admin/settings/companies',
  adminSettingsTemplates: '/admin/settings/templates',

  // Public Event
  publicEventDetails: (eventId: string) => `/event/${eventId}`,

  // Public Booking
  publicBookingDetails: (bookingId: string, eventId: string) =>
    `/booking/${bookingId}?eventId=${eventId}`,
  publicBookingSuccess: (bookingId: string, eventId: string) =>
    `/booking/success/${bookingId}?eventId=${eventId}`,

  // Root
  home: '/not-found',
  notFound: '/not-found',
  error: (title?: string, message?: string) => {
    let value = {}
    if (title) {
      value = { ...value, title: encodeURIComponent(title) }
    }

    if (message) {
      value = { ...value, message: encodeURIComponent(message) }
    }
    const params = new URLSearchParams(value)
    return `/error?${params.toString()}`
  },
}
